{
  "name": "xiframe",
  "version": "2.0.0",
  "type": "module",
  "private": true,
  "description": "allows a customer to launch a Frame session using their SEL Cloud credentials",
  "browserslist": "defaults",
  "engines": {
    "node": ">=24",
    "npm": ">=11"
  },
  "targets": {
    "default": {
      "source": [
        "src/index.html",
        "src/test.html",
        "src/clear.html"
      ],
      "context": "browser",
      "distDir": "dist",
      "outputFormat": "esmodule"
    }
  },
  "scripts": {
    "start": "parcel",
    "dev": "parcel serve",
    "prebuild": "rimraf dist",
    "build": "parcel build --no-cache",
    "build:pr": "parcel build --no-cache --no-source-maps",
    "test": "jest",
    "test:ci": "jest --ci --verbose false",
    "typecheck": "tsc --noEmit -p tsconfig.test.json",
    "format": "prettier --write \"src/**/*.{js,ts,html,css,json}\" \"tests/**/*.{js,ts}\"",
    "format:check": "prettier --check \"src/**/*.{js,ts,html,css,json}\" \"tests/**/*.{js,ts}\"",
    "lint": "eslint src/scripts tests",
    "lint:fix": "eslint src/scripts tests --fix",
    "cm": "cz",
    "preserve": "npm run build",
    "serve": "npx http-serve -c0 dist",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org enercalc-llc --project cloud-login ./dist && sentry-cli sourcemaps upload --org enercalc-llc --project cloud-login ./dist",
    "prepare": "husky"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/enercalc/XiFrameLauncher.git"
  },
  "keywords": [],
  "author": "ENERCALC, LLC <devops@enercalc.com>",
  "license": "ISC",
  "homepage": "https://github.com/enercalc/XiFrameLauncher",
  "devDependencies": {
    "@babel/preset-typescript": "^7.28.5",
    "@eslint/js": "^10.0.1",
    "@futureportal/parcel-transformer-package-version": "^1.0.0",
    "@parcel/babel-plugin-transform-runtime": "^2.16.4",
    "@parcel/babel-preset-env": "^2.16.4",
    "@sentry/cli": "^3.6.2",
    "@types/crypto-js": "^4.2.2",
    "axios-mock-adapter": "^2.1.0",
    "babel-plugin-transform-remove-console": "^6.9.4",
    "buffer": "^6.0.3",
    "crypto-browserify": "^3.12.1",
    "cz-conventional-changelog": "^3.3.0",
    "eslint": "^10.8.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jest": "^29.16.0",
    "events": "^3.3.0",
    "husky": "^9.1.7",
    "jest": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "lint-staged": "^17.0.8",
    "parcel": "^2.16.4",
    "prettier": "^3.9.6",
    "process": "^0.11.10",
    "rimraf": "^6.1.3",
    "sharp": "^0.33.5",
    "stream-browserify": "^3.0.0",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.65.0"
  },
  "dependencies": {
    "@fra.me/terminal-factory": "^7.13.0",
    "@sentry/browser": "^10.67.0",
    "axios": "^1.18.1",
    "crypto-js": "^4.2.0"
  },
  "optionalDependencies": {
    "@parcel/watcher-linux-x64-glibc": "^2.6.0"
  },
  "lint-staged": {
    "src/**/*.{js,ts,html,css,json}": "prettier --write",
    "tests/**/*.{js,ts}": "prettier --write"
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  },
  "@parcel/transformer-js": {
    "inlineEnvironment": [
      "GIT_SHA",
      "SENTRY_*",
      "CODEBUILD_RESOLVED_SOURCE_VERSION"
    ]
  }
}
